// discoveryStateSlice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type ConnectionResponse } from './ApplicationCard';

export interface DiscoveryExistingConnectionState {
  loading: boolean;
  errorData: object | unknown;
  data: ConnectionResponse | null;
}

const initialState: DiscoveryExistingConnectionState = {
  loading: false,
  errorData: null,
  data: null,
};

const discoveryExistingConnectionSlice = createSlice({
  name: 'discoveryExistingConnection',
  initialState,
  reducers: {
    setDiscoveryExistingConnectionLoading: (
      state,
      action: PayloadAction<boolean>
    ) => ({
      ...state,
      loading: action.payload,
    }),
    setDiscoveryExistingConnectionResult: (
      state,
      action: PayloadAction<ConnectionResponse | null>
    ) => ({
      ...state,
      data: action.payload,
    }),
    setDiscoveryExistingConnectionError: (
      state,
      action: PayloadAction<object | unknown>
    ) => ({
      ...state,
      errorData: action.payload,
    }),
    resetDiscoveryExistingConnectionState: () => initialState,
  },
});

export const {
  setDiscoveryExistingConnectionError,
  setDiscoveryExistingConnectionResult,
  setDiscoveryExistingConnectionLoading,
  resetDiscoveryExistingConnectionState,
} = discoveryExistingConnectionSlice.actions;
export default discoveryExistingConnectionSlice;
